import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

export default function PaymentCancel() {
  return (
    <div className="bg-white text-brand-ink min-h-screen">
      <PublicNav />
      <section className="pt-40 pb-32 px-6 text-center max-w-xl mx-auto" data-testid="payment-cancel-page">
        <XCircle className="w-16 h-16 text-brand-ink/40 mx-auto" />
        <h1 className="font-display text-5xl mt-6">Payment cancelled</h1>
        <p className="mt-4 font-serif text-xl text-brand-ink/70">No charge was made. You can try again whenever you're ready.</p>
        <Link to="/" className="mt-10 inline-block px-8 py-4 rounded-full bg-brand-red text-white font-medium hover:bg-brand-reddark transition-colors">Back to home</Link>
      </section>
      <Footer />
    </div>
  );
}
